module.exports = __webpack_public_path__ + "img/lxwm.09cdf2f3.png";